import { useSelector, useDispatch } from "react-redux";

import AIAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/trackingService";
import { setFilterRegenrateSuggestionsMessage } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/lead-generator/store";

import type { SuggestedQueriesStrategyProps } from "../../components/message-strategy";
import { SuggestedQueriesStrategy } from "../../components/message-strategy";
import { incrementGeneratedQueries } from "../../store/action-creators";
import { selectNumberOfGeneratedQueries } from "../../store/selectors";

const SuggestedQueriesContainer = (props: Omit<SuggestedQueriesStrategyProps, "onShowMoreClick">) => {
    const dispatch = useDispatch();

    const numberOfGeneratedQueries = useSelector(selectNumberOfGeneratedQueries);

    const handleOnSuggestionClick = (suggestionText: string): void => {
        AIAgentTrackingService.leadGenerator.trackSuggestedQueryClick(suggestionText, numberOfGeneratedQueries);

        props.onSuggestionClick(suggestionText);
    };

    const handleOnShowMoreClick = async () => {
        AIAgentTrackingService.leadGenerator.trackGenerateMoreClick(numberOfGeneratedQueries + 1);

        const result = await dispatch(setFilterRegenrateSuggestionsMessage());

        if (result?.success) {
            dispatch(incrementGeneratedQueries());
        }
    };

    return (
        <SuggestedQueriesStrategy
            {...props}
            onSuggestionClick={handleOnSuggestionClick}
            onShowMoreClick={handleOnShowMoreClick}
        />
    );
};

export default SuggestedQueriesContainer;
